import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import GallerySection from '../components/GallerySection';
import QuoteFormSection from '../components/QuoteFormSection';
import UploadTestSection from '../components/UploadTestSection';

export default function POCPage() {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--hr-bg)' }}>
      {/* Header simple */}
      <header className="sticky top-0 z-50 border-b" style={{ 
        backgroundColor: 'rgba(245,243,239,0.8)', 
        backdropFilter: 'blur(8px)',
        borderColor: 'var(--hr-border)'
      }}>
        <div className="max-w-[1160px] mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div>
            <h1 className="font-['Playfair_Display'] text-xl font-semibold" style={{ color: 'var(--hr-text)' }}>
              Homely Rénovation
            </h1>
            <p className="text-xs" style={{ color: 'var(--hr-text-muted)' }}>POC - Core Flow Test</p>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="max-w-[1160px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-8">
          <h2 className="font-['Playfair_Display'] text-3xl sm:text-4xl font-semibold mb-3" style={{ color: 'var(--hr-text)' }}>
            POC - Test des fonctionnalités core
          </h2>
          <p className="text-base leading-7" style={{ color: 'var(--hr-text-muted)' }}>
            Cette page teste les 3 fonctionnalités critiques : galerie avant/après, formulaire devis multi-step, et upload d'images.
          </p>
        </div>

        <Tabs defaultValue="gallery" className="w-full">
          <TabsList className="grid w-full grid-cols-3 rounded-xl" style={{ backgroundColor: 'var(--hr-bg-alt)' }}>
            <TabsTrigger 
              value="gallery" 
              data-testid="poc-tab-gallery"
              className="rounded-xl data-[state=active]:bg-[color:var(--hr-primary)] data-[state=active]:text-[color:var(--hr-primary-fg)]"
            >
              Galerie avant/après
            </TabsTrigger>
            <TabsTrigger 
              value="quote" 
              data-testid="poc-tab-quote"
              className="rounded-xl data-[state=active]:bg-[color:var(--hr-primary)] data-[state=active]:text-[color:var(--hr-primary-fg)]"
            >
              Formulaire devis
            </TabsTrigger>
            <TabsTrigger 
              value="upload" 
              data-testid="poc-tab-upload"
              className="rounded-xl data-[state=active]:bg-[color:var(--hr-primary)] data-[state=active]:text-[color:var(--hr-primary-fg)]"
            >
              Test upload
            </TabsTrigger>
          </TabsList>

          <TabsContent value="gallery" className="mt-8">
            <GallerySection />
          </TabsContent>

          <TabsContent value="quote" className="mt-8">
            <QuoteFormSection />
          </TabsContent>

          <TabsContent value="upload" className="mt-8">
            <UploadTestSection />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
}